require('./brokerAccordionIndexesTooltip.scss');
// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
// @ helper
const { formatWithoutRound } = require('utilities/currencyHelper');
// @ utilities
const DateHelper = require('utilities/dateHelper');
// @ constants
const { DATE_FORMAT_SLASHED_ES } = require('constants/index');

class BrokerAccordionIndexesTooltip extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { payload, label, nameValue, active, showDate } = this.props;
        const valueFormatted = payload && payload[0] ? formatWithoutRound(payload[0].value) : null;
        const date = showDate ? `${DateHelper.formatDate(label, DATE_FORMAT_SLASHED_ES)} h` : null;
        const labelNameValue = `${nameValue}: `;
        if (active) {
          return (
              <div className="broker-accordion-indexes-tooltip">
                  <p>
                      {date}
                  </p>
                  <div className="broker-accordion-indexes-tooltip__value">
                      <span>{labelNameValue}</span>
                      <span>{valueFormatted}</span>
                  </div>
              </div>
          );
        }
        return null;
      }
}
BrokerAccordionIndexesTooltip.propTypes = {
    active: PropTypes.bool,
    label: PropTypes.string,
    nameValue: PropTypes.string,
    payload: PropTypes.array.isRequired,
    showDate: PropTypes.bool,
};

BrokerAccordionIndexesTooltip.defaultProps = {
    showDate: true,
}
module.exports = BrokerAccordionIndexesTooltip;
